import { render, staticRenderFns } from "./PageSubHeader.vue?vue&type=template&id=e4fd2364&scoped=true"
import script from "./PageSubHeader.vue?vue&type=script&lang=js"
export * from "./PageSubHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fd2364",
  null
  
)

export default component.exports